/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TicketTimeLimitOverrideValidationError
 */
export interface TicketTimeLimitOverrideValidationError {
    /**
     * 
     * @type {string}
     * @memberof TicketTimeLimitOverrideValidationError
     */
    field?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TicketTimeLimitOverrideValidationError
     */
    message?: string | null;
}

export function TicketTimeLimitOverrideValidationErrorFromJSON(json: any): TicketTimeLimitOverrideValidationError {
    return TicketTimeLimitOverrideValidationErrorFromJSONTyped(json, false);
}

export function TicketTimeLimitOverrideValidationErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): TicketTimeLimitOverrideValidationError {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'field': !exists(json, 'field') ? undefined : json['field'],
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function TicketTimeLimitOverrideValidationErrorToJSON(value?: TicketTimeLimitOverrideValidationError | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'field': value.field,
        'message': value.message,
    };
}


